import { Injectable } from '@angular/core';
import { InvocaService } from 'src/app/base/services/invoca.service';

@Injectable({
  providedIn: 'root'
})
export class AdmisionService {

  constructor(
    private invoke: InvocaService
  ) { }

  async getLogin(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('getLogin', params);
  }

  async saveKeyUser(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('base/saveKeyUser', params);
  }

  async buscarAvisos(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('buscarAvisos', params);
  }

  async buscarEnlaces(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('buscarEnlaces', params);
  }
  async getOpcionesProcesoMatricula(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('getOpcionesProcesoMatricula', params);
  }

  async validarCaptcha(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('validarCaptcha', params);
  }

  valida_rut(rut) {
    if (!isNaN(rut)) {
      return this.calcula_dv(rut);
    } else {
      return "";
    }
  }

  calcula_dv(T) {
    var M = 0, S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + T % 10 * (9 - M++ % 6)) % 11;
    return S ? (S - 1).toString() : 'k';
  }

}
